import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { type FunctionComponent } from "react";
import { Trans, useTranslation } from "react-i18next";

type TechnicalRepairGarageListHintProps = {
  warrantyEnded: boolean;
  firstGarageIsOem: boolean;
};

export const TechnicalRepairGarageListHint: FunctionComponent<
  TechnicalRepairGarageListHintProps
> = ({ warrantyEnded, firstGarageIsOem }: TechnicalRepairGarageListHintProps) => {
  const { t } = useTranslation();

  if (warrantyEnded) return;

  return (
    <>
      <div className="flex rounded-md bg-primary-500 p-4 mb-4 partnerHint transition-all duration-1000">
        <div className="flex-shrink-0 self-center">
          <InformationCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-white">
            {t("hint.technicalRepair.inWarrantyOemHint")}
          </p>
        </div>
      </div>
      {!firstGarageIsOem && (
        <div className="flex rounded-md bg-tertiary p-4 mb-4 partnerHint transition-all duration-1000">
          <div className="flex-shrink-0 self-center">
            <ExclamationCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-white">
              <Trans
                components={{
                  a: (
                    <a
                      className="text-white font-medium"
                      target={"_blank"}
                      rel={"noopener"}
                      href="https://ayvens.de/werkstattpartnersuche"
                    />
                  ),
                }}
                i18nKey={"hint.technicalRepair.inWarrantyNoOemFoundHint"}
              />
            </p>
          </div>
        </div>
      )}
    </>
  );
};
